import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

function PreviewJsonModal({ isOpen, toggle, title, payload }) {
  const formatted = JSON.stringify(payload, null, 2);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{title || "Preview JSON"}</ModalHeader>
      <ModalBody>
        <pre
          style={{
            background: "#f9fafb",
            border: "1px solid #e5e7eb",
            borderRadius: 8,
            padding: 16,
            fontSize: 12,
            maxHeight: "60vh",
            overflow: "auto",
          }}
        >
          {formatted}
        </pre>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default PreviewJsonModal;
